/* MapLibre paint properties are canvas config, not CSS - they can't consume
 * a CSS custom property directly. Rather than duplicate tokens.css's values
 * as a second set of literals, these are read from the resolved :root custom
 * properties at map-init time, so tokens.css stays the one place any of
 * these are declared.
 */
import type { RiskStep } from "../api/types";

export interface MapColors {
  steel: string;
  navy: string;
  white: string;
  risk: Record<RiskStep, string>;
  unmeasured: string;
}

export function readMapColors(): MapColors {
  const style = getComputedStyle(document.documentElement);
  const v = (name: string) => style.getPropertyValue(name).trim();
  return {
    steel: v("--steel"),
    navy: v("--navy"),
    white: v("--white"),
    risk: {
      Acceptable: v("--risk-acceptable"),
      Medium: v("--risk-medium"),
      High: v("--risk-high"),
      Critical: v("--risk-critical"),
    },
    unmeasured: v("--risk-unmeasured"),
  };
}
